// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var RoleCount$ReactHooksTemplate = require("./RoleCount.res.js");
var DomainModel$ReactHooksTemplate = require("./domainModel.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var UserRoleItem$ReactHooksTemplate = require("./UserRoleItem.res.js");

function UserInvitationItem(props) {
  var roles = props.roles;
  var active = props.active;
  var emailText = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, props.email);
  var match = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match[0];
  var activeText = active ? "Active" : "Inactive";
  var activeTextCSS = active ? "text-teal-700" : "";
  var remainingRolesCount = function (xs) {
    var count = List.length(xs);
    if (count !== 0) {
      return JsxRuntime.jsx(RoleCount$ReactHooksTemplate.make, {
                  count: count
                });
    } else {
      return null;
    }
  };
  var match$1;
  if (roles) {
    var match$2 = roles.tl;
    var onlyRole = roles.hd;
    if (match$2) {
      var rest = match$2.tl;
      var secondRole = match$2.hd;
      match$1 = rest ? [
          JsxRuntime.jsx(UserRoleItem$ReactHooksTemplate.make, {
                role: onlyRole
              }),
          JsxRuntime.jsx(UserRoleItem$ReactHooksTemplate.make, {
                role: secondRole
              }),
          remainingRolesCount(rest)
        ] : [
          JsxRuntime.jsx(UserRoleItem$ReactHooksTemplate.make, {
                role: onlyRole
              }),
          JsxRuntime.jsx(UserRoleItem$ReactHooksTemplate.make, {
                role: secondRole
              }),
          null
        ];
    } else {
      match$1 = [
        JsxRuntime.jsx(UserRoleItem$ReactHooksTemplate.make, {
              role: onlyRole
            }),
        null,
        null
      ];
    }
  } else {
    match$1 = [
      null,
      null,
      null
    ];
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                      children: JsxRuntime.jsx("div", {
                            className: "h-4 w-4 rounded border-2 border-platinum"
                          }),
                      className: "w-1/11"
                    }),
                JsxRuntime.jsx("p", {
                      children: emailText,
                      className: "w-1/4 text-xs"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: match$1[0],
                              className: "mr-10-px"
                            }),
                        JsxRuntime.jsx("div", {
                              children: match$1[1],
                              className: "mr-10-px"
                            }),
                        match$1[2]
                      ],
                      className: "flex items-center w-1/4 text-xs"
                    }),
                JsxRuntime.jsx("p", {
                      children: activeText,
                      className: "w-60-px mr-30-px text-xs " + activeTextCSS
                    }),
                JsxRuntime.jsxs("p", {
                      children: [
                        Curry._1(hasPermission, "UpdateUser") ? JsxRuntime.jsx("button", {
                                children: JsxRuntime.jsx("img", {
                                      className: "h-18-px cursor-pointer mr-20-px",
                                      src: Image$ReactHooksTemplate.verticalDots
                                    }),
                                onClick: props.handleEdit
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        Curry._1(hasPermission, "DeleteUser") ? JsxRuntime.jsx("button", {
                                children: JsxRuntime.jsx("img", {
                                      className: "h-20-px cursor-pointer",
                                      src: Image$ReactHooksTemplate.trash
                                    }),
                                onClick: props.handleDelete
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                      ],
                      className: "w-1/4 flex justify-end"
                    })
              ],
              className: "flex items-center p-3"
            });
}

var make = UserInvitationItem;

exports.make = make;
/* react Not a pure module */
